import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
var propTypes = {
  /**
  * Set alignment of Icon and Text horizontally.
  */
  horizontal: PropTypes.bool
};
var IconTileSet = createComponent({
  displayName: 'IconTileSet',
  root: 'div',
  propTypes: propTypes,
  propConfig: {
    classNames: function classNames(props) {
      var classNameSet = new Set(['swan-icon-tile-set']);
      var _props$horizontal = props.horizontal,
          horizontal = _props$horizontal === void 0 ? false : _props$horizontal;
      if (horizontal) classNameSet.add("swan-icon-tile-set-horizontal");
      return classNameSet;
    }
  }
});
IconTileSet.defaultProps = {
  horizontal: false
};
export { IconTileSet };